import React from 'react';

import PropTypes from 'prop-types';

import {ChevronRightIcon} from 'shells/icon';

import {bucketPropType} from './column-picker-types';

const bucketMap = {
    accounts: 'Companies',
    contacts: 'People',
    leads: 'Leads',
};

ColumnPickerBucket.propTypes = {
    bucket: PropTypes.shape(bucketPropType).isRequired,
    onSelect: PropTypes.func.isRequired,
    isSelected: PropTypes.bool,
};

export function ColumnPickerBucket({bucket, onSelect, isSelected = false}) {
    const classes = isSelected ? 'ui-row ui-row--selected ui-row__header' : 'ui-row ui-row__header';

    return (
        <li className={classes} onClick={onSelect}>
            <span className='ui-header-name'>{bucketMap[bucket.name] || bucket.name}</span>
            <span className='ui-header-count'>
                {bucket.numSelected} / {bucket.total}
            </span>
            <button className='ui-btn--icon ui-header-icon'>
                <ChevronRightIcon />
            </button>
        </li>
    );
}
